import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import branchStyle from "assets/jss/material-dashboard-react/views/goldRatesStyle.js";
import CustomTabs from "components/CustomTabs/CustomTabs.js";
import InProess from "./InProcess";
import Submitted from "./Submitted";
import Completed from "./Completed";
import ForApproval from "./ForApproval";
import Disbursal from "./Disbursal";
import Rejected from "./Rejected";
import { useSelector } from "react-redux";
const useStyles = makeStyles(branchStyle);

const Application = ({ featureFlags }) => {
  const { userDetails } = useSelector((state) => state.userDetail.userDetails);
  const currentrole = () => {
    if (userDetails?.role === "role_maker") {
      return [
        {
          tabName: "In Process ",
          tabContent: <InProess featureFlags={featureFlags} />,
        },
        {
          tabName: "Submitted",
          tabContent: <Submitted featureFlags={featureFlags} />,
        },

        {
          tabName: "Disbursal",
          tabContent: <Disbursal featureFlags={featureFlags} />,
        },
        {
          tabName: "Completed",
          tabContent: <Completed featureFlags={featureFlags} />,
        },
        {
          tabName: "Rejected",
          tabContent: <Rejected featureFlags={featureFlags} />,
        },
      ];
    } else if (userDetails?.role === "role_checker") {
      return [
        {
          tabName: "For Approval",
          tabContent: <ForApproval />,
        },
      ];
    } else {
      return [
        {
          tabName: "In Process ",
          tabContent: <InProess featureFlags={featureFlags} />,
        },
        {
          tabName: "Submitted",
          tabContent: <Submitted featureFlags={featureFlags} />,
        },
        {
          tabName: "For Approval",
          tabContent: <ForApproval />,
        },
        {
          tabName: "Disbursal",
          tabContent: <Disbursal featureFlags={featureFlags} />,
        },
        {
          tabName: "Completed",
          tabContent: <Completed featureFlags={featureFlags} />,
        },
        {
          tabName: "Rejected",
          tabContent: <Rejected featureFlags={featureFlags} />,
        },
      ];
    }
  };
  return (
    <>
      <GridContainer justfly="center">
        <GridItem xs={12} sm={12} md={12} lg={12}>
          <CustomTabs
            headerColor="Gray"
            tabs={currentrole()}
          />
        </GridItem>
      </GridContainer>
    </>
  );
};

Application.propTypes = {
  classes: PropTypes.object,
  setNext: PropTypes.func,
  setBack: PropTypes.func,
};

export default Application;
